var getParamValue = function getParamValue(url, key) {
  var regex = new RegExp(key + '=([^&]*)', 'i');
  return url.match(regex) ? url.match(regex)[1] : null;
};
var getCookie = function getCookie(name) {
  var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
  if (arr != null) {
    return decodeURI(arr[2]);
  }
  return null;
};
var setCookie = function setCookie(name, value, host, days) {
  var time = '';
  if (days) {
    var d = new Date();
    var offset = 8;
    var utc = d.getTime() + d.getTimezoneOffset() * 60000;
    var nd = utc + 3600000 * offset;
    var exp = new Date(nd);
    exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
    time = "expires=".concat(exp.toGMTString(), ";");
  }
  document.cookie = "".concat(name, "=").concat(value, ";path=/;").concat(time, "domain=.").concat(host, ";");
};
var escapeHtml = function escapeHtml(text) {
  return text.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/“/g, '&ldquo;').replace(/”/g, '&rdquo;').replace(/ /g, '&nbsp;').replace(/×/g, '&times;');
};
var delCookie = function delCookie(name, host) {
  var cval = getCookie(name);
  if (cval != null) {
    document.cookie = "".concat(name, "=").concat(cval, ";domain=.").concat(host, ";expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;");
  }
};
var isConsleA = function isConsleA(ele) {
  var _a, _b;
  return ele.tagName === 'A' && (((_a = ele.getAttribute('href')) === null || _a === void 0 ? void 0 : _a.includes('console.bce.baidu.com')) || ((_b = ele.getAttribute('href')) === null || _b === void 0 ? void 0 : _b.includes('bcetest.baidu.com')));
};
// 查找console超链接的href
var _findConsoleHref = function findConsoleHref(ele) {
  if (isConsleA(ele)) {
    return ele.getAttribute('href');
  }
  var parentNode = ele.parentNode;
  if (!parentNode) {
    return null;
  }
  if (isConsleA(parentNode)) {
    return parentNode.getAttribute('href');
  }
  if (parentNode.tagName === 'BODY') {
    return null;
  }
  return _findConsoleHref(parentNode);
};

export { delCookie, escapeHtml, _findConsoleHref as findConsoleHref, getCookie, getParamValue, isConsleA, setCookie };
